import http from 'utils/http';
import { getAgencyConfigurationUrl } from './apiUrl';
import { ConfigurationResponse } from './types';

export function getAgencyConfiguration(): Promise<ConfigurationResponse> {
  return http.get(getAgencyConfigurationUrl());
}

export function updateAgencyConfiguration(payload: ConfigurationResponse): Promise<ConfigurationResponse> {
  return http.put(getAgencyConfigurationUrl(), payload);
}
